//frontend/frontend/src/components/SubjectsPage2.jsx

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
//import '../pages/journeybuttons.css';
//import '../pages/campfirepage.css';
import Crystal from './crystal.jsx';
import axios from 'axios';
import './SubjectsPage.css';
import api from '../api.js'

 
  
function SubjectsPage({ 
  title, 
  backgroundImage, 
  subTopics, 
  backRoute, 
  chapterFooter 
}) {

  const navigate = useNavigate();
  const [progress, setProgress] = useState({});
  const token = localStorage.getItem('access_token');

useEffect(() => {
  const fetchAllProgress = async () => {
    const updatedProgress = {};
    const token = localStorage.getItem('access_token');   // <-- ensure it exists
    console.log('URL:', `${process.env.REACT_APP_API_URL}/api/progress/`);

    if (!token) {
      console.warn('No access token found');
      setProgress(Object.fromEntries(subTopics.map(t => [t.key, 0])));
      return;
    }

    try {
      // parallelize requests
      console.log('Auth header:', `Bearer ${token}`.slice(0, 20) + '…');
      const requests = subTopics.map(t =>
        api.get(`${process.env.REACT_APP_API_URL}/api/progress/`, {
          params: { sub_topic: t.key },
          withCredentials: false,                          // <-- no cookies
          headers: { Authorization: `Bearer ${token}` },   // <-- JWT on every call
        }).then(res => [t.key, res.data.percent_correct])
         .catch(() => [t.key, 0])
      );

      const results = await Promise.all(requests);
      setProgress(Object.fromEntries(results));
    } catch (e) {
      console.error('Failed to fetch progress:', e);
      setProgress(Object.fromEntries(subTopics.map(t => [t.key, 0])));
    }
  };

  fetchAllProgress();
}, [subTopics]);








  const renderCrystals = (percent) => {
    const thresholds = [33.33, 66.66, 99.99];
    return thresholds.map((t, idx) => (
      <Crystal key={idx} size={15} locked={percent < t} />
    ));
  };

 
  return (
    <div style={{ backgroundColor: '#000', height: '100vh', display: 'flex', flexDirection: 'column', fontFamily: 'sans-serif', color: 'white' }}>
      <div className='medieval-text' style={{ height: '5vh', backgroundColor: '#111', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '2rem' }}>
        {title}
      </div>


<div className="subject-background-wrapper">
  <img src={backgroundImage} alt="Subject Background" className="subject-background-image" />
        
        
<div
  className="responsive-back-button"
  style={{
    position: 'absolute',
    zIndex: 3,
  }}
>
  <button
    className="back-button"
    onClick={() => navigate(backRoute)}
  >
    ⬅ Back
  </button>
</div>


          




        <div style={{ position: 'absolute', top: '10%', left: '50%', transform: 'translateX(-50%)', display: 'flex', flexDirection: 'column', gap: '1rem', zIndex: 1 }}>
          {subTopics.map((topic) => {
            const topicProgress = progress[topic.key] || 0;
            return (
              <div key={topic.key} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.3rem' }}>
                <button className="journey-buttonX" onClick={() => navigate(topic.route)}>
                  {topic.name}
                </button>
                <div style={{ display: 'flex', gap: '0.3rem' }}>
                  {renderCrystals(topicProgress)}
                </div>
              </div>
            );
          })}
        </div>
      </div>


      <div style={{ height: '7vh', backgroundColor: '#111', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.2rem' }}>
        {chapterFooter}
      </div>
    </div>
  );
}

export default SubjectsPage;
